import type { Handleiding } from './soort';

export const zh: Handleiding = {
  code: 'zh',
  titel: '使用说明',
  inleiding: 'Ask Gio Tolk 为两个语言不通的人翻译对话。下面写明每个按钮的作用。',
  knop: '打开使用说明',
  sluiten: '关闭',
  groepGebruik: '参与对话',
  groepBeheer: '设置与管理',
  delen: [
    {
      titel: '说话',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: '说话',
          uitleg: '点一下开始。当你安静超过一秒钟，录音会自动停止，再点一下也会停止。一分钟后无论如何都会停止。',
        },
        {
          kop: '一次只有一个声音',
          uitleg: '只要应用在说话，你就不能录音。而只要你在录音，收到的翻译就会等你说完。否则你的麦克风会把应用录进去，并以为那是你说的。',
        },
        {
          kop: '在这里输入你的消息',
          uitleg: '和说话并行，走同一套翻译。回车发送，Shift 加回车换行。',
        },
        {
          kop: '修改时间',
          uitleg: '在这里设置你有多少秒来复看转写出来的句子，然后它才发出去。设为零就立刻发出。',
        },
        {
          kop: '始终自己检查再发送',
          uitleg: '不再有倒计时。每句话都等你按发送。适合想检查每一句的人。',
        },
        {
          kop: '立即播放翻译',
          uitleg: '已开启。如果你更愿意先读，再自己决定什么时候听，就把它关掉。',
        },
      ],
    },
    {
      titel: '读消息',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: '显示为大字的内容',
          uitleg: '用你的语言写的内容显示为大字。在你自己的句子里，那是你的原文，方便你检查应用有没有听对。在对方的句子里，那是译文。',
        },
        {
          kop: '展开原文或译文',
          uitleg: '另一种语言在下面，收起着。点那一行就能打开。',
        },
        {
          kop: '小三角',
          uitleg: '重新播放译文。',
        },
        {
          kop: '会说话的头像',
          uitleg: '播放对方本人的录音。只在说出来的消息上出现，而且只有开启「同时发送你自己的声音」时才有。打字的消息没有录音。',
        },
      ],
    },
    {
      titel: '屏幕上方的按钮',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: '减号和加号',
          uitleg: '把文字变小或变大。分五档，而且会保存下来。',
        },
        {
          kop: '麦克风',
          uitleg: '如果你反正只打字，就隐藏说话按钮。这样能省地方。',
        },
        {
          kop: '键盘',
          uitleg: '隐藏文本框。两者中始终留一个开着，否则你就什么都说不了了。',
        },
      ],
    },
    {
      titel: '进入',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: '你说哪种语言',
          uitleg: '这个选择同时决定按钮和提示的语言。所以你们两人看到的界面不一样，这是有意的。',
        },
        {
          kop: '你在译文里的声音',
          uitleg: '选择你听起来像男声还是女声。这属于你自己，不属于房间：两位参与者各自选择。',
        },
        {
          kop: '麦克风权限',
          uitleg: '浏览器在进入时会询问。如果你拒绝，仍然可以打字。之后也可以通过地址栏里的小锁再授权。',
        },
      ],
    },
    {
      titel: '底部，收起的部分',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: '备用词表',
          uitleg: '必须始终用同一种方式翻译的词：人名、专业术语、品牌。对整个房间有效。',
        },
        {
          kop: '修改设置',
          uitleg: '语言、声音、语气和拼写更正在对话进行中也能改。你在这里改的内容立刻对两个人生效。',
        },
      ],
    },
    {
      titel: '开始一场对话',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: '对话的名称',
          uitleg: '可以留空。它只显示在你屏幕的上方，让你知道在和谁说话。',
        },
        {
          kop: '说话人 1 和说话人 2',
          uitleg: '这场对话的两种语言。先进来的人占第一个位置。语言之后还可以互换。',
        },
        {
          kop: '译文的语气',
          uitleg: '左边选择用「你」还是用「您」，右边选择气氛：中性、友好、商务、正式或伴侣。没有指引时，模型几乎总是选择正式的说法，在普通对话里听起来显得疏远。',
        },
        {
          kop: '同时发送你自己的声音',
          uitleg: '对方除了译文之外还能听到你自己的录音。学语言时很方便。谈敏感话题时把它关掉：收到录音的人可以保存下来。',
        },
        {
          kop: '更正你自己文本中的拼写错误',
          uitleg: '已开启。关掉它就能看到模型真正听懂了什么。如果出现奇怪的句子，你就知道是听错了，还是听对了之后被润色过。',
        },
        {
          kop: '带 PIN 码',
          uitleg: '口头告知这个码，不要和链接放在同一条消息里。这样可以防止链接被转发。',
        },
        {
          kop: '二维码',
          uitleg: '让对方扫描，或者发送链接。房间四小时后自动失效。',
        },
      ],
    },
    {
      titel: '你的对话会怎么样',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: '文字不会被保存',
          uitleg: '你们说的话不会进入数据库。只记录什么时候说了多少，用于计算费用。',
        },
        {
          kop: '录音会自动消失',
          uitleg: '音频在内存里保留十分钟，然后就没了。',
        },
        {
          kop: '房间会失效',
          uitleg: '创建后四小时。之后链接就不再有效。',
        },
        {
          kop: '有预算限制',
          uitleg: '按房间和按月计算。用满了，应用就会停止翻译并说明。这不是故障。',
        },
      ],
    },
  ],
};
